import type { SimulationSnapshot } from "./simulation";

export type PolarityAdminLevelInput = SimulationSnapshot["level"] | number;

export type PolarityAdminAction =
  | { type: "forcePassLevel" }
  | { type: "skipLevel" }
  | { type: "previousLevel" }
  | { type: "jumpToLevel"; level: PolarityAdminLevelInput }
  | { type: "addScore"; amount: number };

export interface PolarityAdminState {
  level: SimulationSnapshot["level"];
  status: SimulationSnapshot["status"];
  availableActions: PolarityAdminAction["type"][];
}

export interface PolarityAdminResult {
  ok: boolean;
  action: PolarityAdminAction["type"];
  message: string;
  snapshot: SimulationSnapshot;
}

export interface PolarityAdminApi {
  getState(): PolarityAdminState;
  execute(action: PolarityAdminAction): PolarityAdminResult;
  forcePassLevel(): PolarityAdminResult;
  skipLevel(): PolarityAdminResult;
  previousLevel(): PolarityAdminResult;
  jumpToLevel(level: PolarityAdminLevelInput): PolarityAdminResult;
  addScore(amount: number): PolarityAdminResult;
}

interface PolarityAdminHandlers {
  getState(): PolarityAdminState;
  forcePassLevel(): PolarityAdminResult;
  skipLevel(): PolarityAdminResult;
  previousLevel(): PolarityAdminResult;
  jumpToLevel(level: PolarityAdminLevelInput): PolarityAdminResult;
  addScore(amount: number): PolarityAdminResult;
}

export function createPolarityAdminApi(handlers: PolarityAdminHandlers): PolarityAdminApi {
  return {
    getState: handlers.getState,
    execute(action: PolarityAdminAction): PolarityAdminResult {
      switch (action.type) {
        case "forcePassLevel":
          return handlers.forcePassLevel();
        case "skipLevel":
          return handlers.skipLevel();
        case "previousLevel":
          return handlers.previousLevel();
        case "jumpToLevel":
          return handlers.jumpToLevel(action.level);
        case "addScore":
          return handlers.addScore(action.amount);
      }
    },
    forcePassLevel: handlers.forcePassLevel,
    skipLevel: handlers.skipLevel,
    previousLevel: handlers.previousLevel,
    jumpToLevel: handlers.jumpToLevel,
    addScore: handlers.addScore,
  };
}
